import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getVisitorId = () => {
  try {
    let v = localStorage.getItem("fw_vid");
    if (!v) {
      v = window.crypto?.randomUUID ? window.crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem("fw_vid", v);
    }
    return v;
  } catch {
    return "anon";
  }
};

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const body = JSON.stringify({
      path: location.pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    });
    try {
      fetch(`${API}/analytics/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch {}
  }, [location.pathname]);

  return null;
};

export default PageTracker;
